/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { ReactElement } from 'react';
import shallow from 'zustand/shallow';
// eslint-disable-next-line import/no-named-default
// import { default as FadeInText } from 'react-fade-in';
import { IonIcon } from '@ionic/react';
import { FiX } from 'react-icons/fi';
import { BsArrowRightShort } from 'react-icons/bs';
import { Button, Text, Icon as ChakraIcon, Flex } from '@chakra-ui/react';
import { Icon } from 'rsuite';
import { closeOutline } from 'ionicons/icons';
import { FaLightbulb } from 'react-icons/fa';
import { Prompt, PromptState, User } from '../../../@types';
import { WaveBottom } from '../../../theme/global';
import { PromptLikeButton } from './PromptLikeButton';
import { PromptNoteButton } from './PromptNoteButton';
import { PromptCommentButton } from './PromptCommentButton';
import { PromptComments } from './PromptComments';
import { QuestionPromptWrapper } from './QuestionPromptWrapper';

import * as Constants from '../../../constants';
import { useEpisodeStore } from '../../../store';
import { usePromptLike, usePromptComments } from '../../../api';
import { showNotification } from '../../notification';
import {
  PromptWrapper,
  PromptImage,
  PromptHeader,
  PromptBody,
  PromptActionBarContainer,
  PromptContinueButton,
} from '../styles/PromptStyles';
import { WaveBackground } from '../../../components/waveBackground/WaveBackground';
import { timestampToMinutes } from './Marker';

interface PromptActionBarActions {
  TOGGLE_PROMPT_COMMENTS: () => void;
  HANDLE_PROMPT_LIKE: () => void;
  HANDLE_PROMPT_SAVE: (id: string, saved: boolean) => void;
}

const PromptActionBar: React.FC<{
  state: PromptState;
  actions: PromptActionBarActions;
}> = ({ state, actions }) => {
  const { id: promptId = '' } = state.prompt || {};
  // const { data: comments = [], isLoading } = usePromptComments(promptId);
  return (
    <PromptActionBarContainer>
      {state.prompt && (
        <>
          {/* <PromptLikeButton
            prompt={state.prompt}
            handlePromptLike={actions.HANDLE_PROMPT_LIKE}
          /> */}
          {actions && actions.TOGGLE_PROMPT_COMMENTS && (
            <PromptCommentButton
              togglePromptComments={actions.TOGGLE_PROMPT_COMMENTS}
            />
          )}
          {/* <PromptNoteButton
            prompt={state.prompt}
            handlePromptSaveNote={actions.HANDLE_PROMPT_SAVE}
          /> */}
        </>
      )}
    </PromptActionBarContainer>
  );
};

const CloseButton: React.FC<{
  prompt: Prompt;
  closePrompt: (prompt: Prompt) => void;
}> = ({ prompt, closePrompt }) => {
  // const [state, dispatch] = usePrompt();
  // const { answered } = state;
  const { prompt_type_id } = prompt;
  const isQuestion = prompt_type_id === Constants.PROMPT_TYPE_IDS.QUESTION;
  const answered = isQuestion;
  const buttonText =
    isQuestion && answered ? 'Continue watching' : 'Skip Question';
  return (
    <Button
      aria-label="Close Prompt"
      lineHeight={1}
      className={`btn btn-close-prompt ${
        isQuestion ? 'skip-question' : 'skip-question'
      }`}
      {...(!!answered && {
        leftIcon: <ChakraIcon boxSize={6} as={BsArrowRightShort} />,
      })}
      {...(!answered && {
        px: 1,
        sx: {
          '.chakra-button__icon': {
            mr: 0,
          },
        },
        bg: 'darkBlue.500',
        _hover: {
          bg: 'darkBlue.500',
          color: 'white',
        },
        _active: {
          bg: 'newGreen.500',
        },
        size: 'sm',
        leftIcon: <ChakraIcon fontSize={16} as={FiX} />,
      })}
      onClick={(e) => closePrompt(prompt)}
    >
      {isQuestion && buttonText}
    </Button>
  );
};

const FadeText: React.FC<{ text: string; show: boolean }> = ({
  text,
  show,
}) => {
  const words = text.split(' ');
  const wordGroups = [] as string[];
  let counter = 0;
  let currentString = ' ';
  words.forEach((word: string, i: number) => {
    currentString += `${word} `;
    counter += 1;
    if (counter > 1) {
      wordGroups.push(currentString);
      counter = 0;
      currentString = ' ';
    } else if (i === words.length - 1) {
      wordGroups.push(currentString);
    }
  });
  let delay = 0;
  return (
    <div className={`fade-text-wrapper ${show ? 'show' : ''}`}>
      {wordGroups.map((group, i) => {
        delay += 100;
        return (
          <span
            style={{
              transitionDelay: `${delay}ms`,
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={`text-${i}`}
          >
            {group}
          </span>
        );
      })}
    </div>
  );
};

interface EpisodeVideoPromptProps {
  prompt: Prompt;
  closePrompt: (prompt: Prompt) => void;
  user: User;
}
export const EpisodeVideoPrompt: React.FC<EpisodeVideoPromptProps> = ({
  prompt,
  closePrompt,
  user,
}): ReactElement | null => {
  // const { data: prompt } = usePrompt(promptId);

  const { getPromptStateById, PROMPT_ACTIONS } = useEpisodeStore((s) => ({
    PROMPT_ACTIONS: s.PROMPT_ACTIONS,
    getPromptStateById: s.getPromptStateById,
  }));
  const state = prompt ? getPromptStateById(prompt.id) : null;

  const { mutate: togglePromptLikeMutation } = usePromptLike();

  const { prompt_type_id } = prompt;

  // console.log('re-rendered prompt', prompt ? prompt.id : 'no id');

  const togglePromptComments = () => {
    if (prompt) {
      PROMPT_ACTIONS.togglePromptComments(prompt.id);
    }
  };

  const handlePromptLike = () => {
    if (prompt) {
      togglePromptLikeMutation({ prompt_id: prompt.id, user_id: user.id });
    }
  };

  const handlePromptSave = (id: string, saved: boolean) => {
    if (saved) {
      showNotification({
        type: 'success',
        title: 'Saved!',
        message: 'The bubble was saved to your notes!',
      });
    } else {
      showNotification({
        type: 'info',
        title: 'Removed',
        message: 'The bubble was removed from your notes.',
      });
    }
  };

  const actionBarActions: PromptActionBarActions = {
    TOGGLE_PROMPT_COMMENTS: togglePromptComments,
    HANDLE_PROMPT_LIKE: handlePromptLike,
    HANDLE_PROMPT_SAVE: handlePromptSave,
  };

  const wrapperClasses = state
    ? `prompt-wrapper type-${prompt && prompt_type_id} ${
        prompt && prompt_type_id !== Constants.PROMPT_TYPE_IDS.QUESTION
          ? `pos-${prompt.position}`
          : ''
      } ${prompt && state.isOpen ? 'show' : ''} ${
        !state.responsesOpen ? '' : 'responses-open'
      }`
    : '';

  const strippedText = prompt.text.replace(/<[^>]+>/g, '');

  return (
    <>
      {state && prompt && state.prompt && (
        <PromptWrapper
          aria-disabled={!state.isOpen}
          aria-hidden={!state.isOpen}
          aria-label={`${prompt.title}`}
          aria-modal
          aria-describedby={`prompt-text-${prompt.id}`}
          className={wrapperClasses}
        >
          {prompt.prompt_type_id === Constants.PROMPT_TYPE_IDS.QUESTION ? (
            <>
              <Flex
                pt={4}
                pb={6}
                display="flex"
                flexDir="column"
                gap={4}
                bg="darkBlue.500"
                color="white"
                position="relative"
                borderRadius={10}
              >
                <Text fontWeight={800} textAlign="center">
                  Pod activity
                </Text>
                <CloseButton prompt={prompt} closePrompt={closePrompt} />
              </Flex>
              <WaveBackground
                bg="white"
                py={4}
                pb={0}
                flexDir="column"
                gap={5}
                borderRadius={12}
                alignItems="center"
              />
            </>
          ) : (
            <PromptHeader>
              <CloseButton prompt={prompt} closePrompt={closePrompt} />
            </PromptHeader>
          )}

          <PromptBody
            className={`${
              state.commentsOpen ? 'comments-open' : ''
            } type-${prompt_type_id}`}
          >
            <div className="body-inner">
              {prompt.media_type_id &&
                prompt.media_src &&
                prompt.media_type_id === Constants.MEDIA_TYPE_IDS.IMAGE && (
                  <PromptImage src={prompt.media_src} />
                )}
              <Flex flexDir="column">
                {prompt.prompt_type_id !==
                  Constants.PROMPT_TYPE_IDS.QUESTION && (
                  <Flex px={30} pb={4} pt={7} ml={5} gap={2}>
                    <ChakraIcon
                      fontSize={42}
                      color="darkBlue.500"
                      as={FaLightbulb}
                      bg="newGreen.500"
                      p={2}
                      borderRadius="full"
                    />
                    <Flex flexDir="column">
                      <Text
                        px={2}
                        bg="newGreen.500"
                        w="fit-content"
                        borderRadius="full"
                        fontSize={12}
                      >
                        {timestampToMinutes(prompt.timestamp)}
                      </Text>
                      <Text fontWeight={800} textAlign="center" mt={0}>
                        {prompt.title}
                      </Text>
                    </Flex>
                  </Flex>
                )}
                {prompt_type_id === Constants.PROMPT_TYPE_IDS.INFO ||
                prompt_type_id === Constants.PROMPT_TYPE_IDS.QUESTION ? (
                  <Text
                    lineHeight={{ base: 1 }}
                    id={`prompt-text-${prompt.id}`}
                    className={`body-text ${
                      prompt.text.length < 200 ? 'larger' : ''
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: strippedText,
                    }}
                  />
                ) : null}
                {prompt_type_id === Constants.PROMPT_TYPE_IDS.TEXT && (
                  <FadeText show={state.isOpen} text={prompt.text} />
                )}
              </Flex>
            </div>
            {prompt_type_id === Constants.PROMPT_TYPE_IDS.QUESTION && (
              <QuestionPromptWrapper prompt={prompt} />
            )}
            {prompt_type_id === Constants.PROMPT_TYPE_IDS.INFO && (
              <PromptComments
                togglePromptComments={togglePromptComments}
                state={state}
                prompt={prompt}
              />
            )}
          </PromptBody>
          {prompt_type_id === Constants.PROMPT_TYPE_IDS.INFO && (
            <>
              <PromptContinueButton>
                <button
                  type="button"
                  className="btn btn-continue"
                  onClick={(e) => closePrompt(prompt!)}
                >
                  Continue
                  <Icon icon="long-arrow-right" />
                  <span>(or press spacebar)</span>
                </button>
              </PromptContinueButton>
              <PromptActionBar state={state} actions={actionBarActions} />
            </>
          )}
        </PromptWrapper>
      )}
    </>
  );
};
